import * as React from 'react';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { translateValue } from '../utils';
function getParametersChanges(_a) {
    var source = _a.source, accurity = _a.accurity;
    if (source && accurity) {
        return { next: source, previous: (accurity !== source) ? accurity : undefined };
    }
    else if (source) {
        return { next: source };
    }
    else if (accurity) {
        return { next: accurity };
    }
    throw new Error('At least one of source | accurity must be given');
}
export default function ChangeCell(_a) {
    var change = _a.change, translator = _a.translator;
    var _b = getParametersChanges(change), next = _b.next, previous = _b.previous;
    var nextValue = translator ? translateValue(next, translator) : next;
    var previousValue = (translator && previous) ? translateValue(previous, translator) : previous;
    var hasPreviousValue = !!previousValue;
    return (React.createElement(Tooltip, { title: hasPreviousValue ? "Before: " + previousValue : '' },
        React.createElement(Typography, { fontWeight: hasPreviousValue ? 800 : undefined, lineHeight: "inherit", fontSize: "inherit" }, nextValue)));
}
//# sourceMappingURL=DataStructureSyncSelectionDialogChangeCell.js.map